import http from "../helpers/httpCommon";

class GroupService {
    create(data) {
        return http().post("/galleriesCreate", data);
    }

    read(data) {
        return http().post("/galleriesRead", data);
    }

    update(data) {
        return http().post(`/galleriesUpdate`, data);
    }

    delete(data) {
        return http().post(`/galleriesDelete`, data);
    }

    list(data) {
        return http().post("/galleriesList", data)
    }
}

export default new GroupService();
